/**
 * Convert a string to title case.
 *
 * @param {string | null | undefined} value - Raw string to transform.
 * @returns {string} Title-cased representation, or empty string when input is blank.
 */
export function titleize(value) {
  if (!value) return ""

  return String(value)
    .replace(/[_-]+/g, " ")
    .replace(/\b\w/g, char => char.toUpperCase())
}
